import { useEffect } from "react"
import Axios from "axios"
import { useImmerReducer } from "use-immer"
import { POPULAR_BASE_URL } from "../helpers/config"

export const useMovieFetch = () => {
  const initialState = {
    movies: [
      {
        id: "",
        overview: "",
        release_date: "",
        adult: "",
        backdrop_path: "",
        vote_count: "",
        genre_ids: [],
        vote_average: "",
        original_language: "",
        original_title: "",
        poster_path: "",
        title: "",
        video: "",
        popularity: "",
        media_type: "",
      },
    ],
    isMovieFetching: "",
    isTvFetching: "",
    page: 1,
    loadMoreRequestCount: 0,
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadMovies":
        draft.movies = action.data
        return
      case "loadMoreMovies":
        draft.movies = draft.movies.concat(action.data)
        return
      case "fetchingRequestStart":
        draft.isMovieFetching = action.value
        return
      case "loadMore":
        draft.page = draft.page + 1
        draft.loadMoreRequestCount = draft.loadMoreRequestCount + 1
        return
      default:
        console.log("our")
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  const fetchMovie = async (ourRuqest) => {
    try {
      let response = await Axios.get(`${POPULAR_BASE_URL}${state.page}`, { cancelToken: ourRuqest.token })
      if (state.page > 1) {
        dispatch({ type: "loadMoreMovies", data: response.data.results })
      } else {
        dispatch({ type: "loadMovies", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    let ourRequest = Axios.CancelToken.source()
    fetchMovie(ourRequest)
    return () => {
      ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page])

  let movies = state.movies

  return [movies, dispatch]
}
